// extracted by mini-css-extract-plugin
export default {"root":"ByZxtorcNblG3zQkmTxV","canvas":"rEc9L8u6RsXj6xOy30uG"};